import * as React from 'react'
import * as ReactDOM from 'react-dom'

import { useZIndex } from '../state/ZIndex'

interface PortalProps {
  children: React.ReactNode
  container?: HTMLElement
}

const useOverlayContainer = ({
  parent = document.body,
  position = 'fixed',
}) => {
  const ref = React.useRef<any>(null)

  const zIndex = useZIndex({})

  if (!ref.current) {
    // update context
    zIndex.increment()
    // initialize node
    ref.current = document.createElement('div')
    // style node layout
    ref.current.style.position = position
    ref.current.style.top = '0'
    ref.current.style.left = '0'
    // insert node
    parent.appendChild(ref.current)
  }

  // Observe zIndex.value and update node
  React.useLayoutEffect(() => {
    ref.current && (ref.current.style.zIndex = String(zIndex.value))
  }, [zIndex.value])

  // Cleanup node on unmount
  React.useEffect(
    () => () => {
      ref.current && parent.removeChild(ref.current)
    },
    []
  )

  return ref.current
}

const Portal = ({
  children,
  container = useOverlayContainer({}),
}: PortalProps) => container && ReactDOM.createPortal(children, container)

export default Portal
